/* import __COLOCATED_TEMPLATE__ from './reviewable-scores.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-scores.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));